import { useCallback } from 'react';
import { Checkbox, Flex, Typography } from '@banhala/ui-kit';
import { type NavigationProp, useNavigation } from '@react-navigation/native';
import type { OneCheckboxFilterProps } from './types';
import { bridge } from '../../../../utils';
import { useFilterListAtom } from '../FilterList/Provider/filterList/useFilterListAtom';

export const OneCheckboxFilter = ({
  entity,
  logging,
  scrollToFilterList,
}: OneCheckboxFilterProps) => {
  const navigation = useNavigation<
    NavigationProp<{
      [route: string]: Record<string, string[] | undefined>;
    }>
  >();
  const { setFilterListAtom } = useFilterListAtom();

  const item = entity?.[0];

  const handleToggle = useCallback(() => {
    if (!item) return;
    const nextIsOn = !item.item.is_on;

    bridge.logAnalyticsEvent({
      name: 'CLICK_CHECKBOX_FILTER',
      analytics: {
        ...logging?.analytics,
        ...item.logging?.analytics,
        IS_ON: nextIsOn,
      },
      ably_only_log: { ...logging?.ably_only_log, ...item.logging?.ably_only_log },
    });

    scrollToFilterList();
    const nextValue = nextIsOn ? [`${item.item.query_value}`] : undefined;
    setFilterListAtom(prev => ({
      ...prev,
      [item.item.query_name]: nextValue,
    }));
    navigation.setParams({ [item.item.query_name]: nextValue });
  }, [item, logging, scrollToFilterList, setFilterListAtom, navigation]);

  if (!item) return null;

  return (
    <Flex.Row
      alignItems="center"
      padding={{ horizontal: 16 }}
      height={36}
      gap={4}
      onPress={handleToggle}
    >
      <Checkbox
        value={item.item.is_on}
        onPress={handleToggle}
      />
      <Typography
        type="body2"
        color={item.item.is_on ? 'content_pink_primary' : 'content_tertiary'}
      >
        {item.item.title}
      </Typography>
    </Flex.Row>
  );
};
